import { render } from "./ListeTypeHospitalisation.vue?vue&type=template&id=38275a88&scoped=true"
import script from "./ListeTypeHospitalisation.vue?vue&type=script&lang=js"
export * from "./ListeTypeHospitalisation.vue?vue&type=script&lang=js"

import "./ListeTypeHospitalisation.vue?vue&type=style&index=0&id=38275a88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38275a88"]])

export default __exports__